//
//
//
//
//
//
//
//
//

import listArrange from '@/components/temporary/list-arrange'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
export default {
  name: "qualityTp",
  data() {
    return {
      listHeaderTemplateBoard: {},
      listArrange: [],
      approvalTemplateBoard: {}
    }
  },
  props: ['data'],
  created() {
    let templateData = this.data;
    this.listHeaderTemplateBoard = {
      template: listHeaderTemplate.contractQueryV2,
      data() {
        return {
          title: [templateData.supplierName,],
          desc: []
        }
      }
    },
      this.listArrange = [
        {
          icon: "fa fa-file-text-o font-size-mr",
          span: 21,
          templateBoard: {
            template: "<span class=\"black arrange_weight_100 opacity7\">{{matName}}</span>",
            data() {
              return {
                matCode: templateData.material?templateData.material.matCode:"",
                matName: templateData.material?templateData.material.matName:"",
              }
            }
          }
        },
        {
          icon: "",
          span: 3,
          templateBoard: {
            template: "<span class=\"arrange_float_right\">x{{amount}}</span>",
            data() {
              return {
                amount: templateData.amount,
              }
            }
          }
        },
        {
          icon: "fa fa-file-text-o font-size-mr",
          span: 9,
          display: templateData.planCycleFrom,
          templateBoard: {
            template: "<span class=\"black opacity7\"> {{checkerName}}</span>",
            data() {
              return {
                checkerName: templateData.qualityTable.checkerName,
              }
            },
            components: {
              divSpan
            }
          }
        },
        {
          icon: "fa fa-calendar-check-o",
          span: 10,
          templateBoard: {
            template: "<span class=\"black opacity7\">{{testDate | dateFormat('YYYY-MM-DD')}}</span>",
            data() {
              return {
                testDate: templateData.qualityTable.testDate,
              }
            },
            components: {
              divSpan
            }
          }
        },
        {
          icon: templateData.qualityTable.testType?"fa fa-file-text-o font-size-mr":"",
          span: 5,
          templateBoard: {
            template: listHeaderTemplate.qualityTestType,
            data() {
              return {
                status: templateData.qualityTable.testType,
              }
            },
            components: {
              divSpan
            }
          }
        }
      ],
      this.approvalTemplateBoard = {
        template: listHeaderTemplate.qualityStatus,
        data() {
          return {
            status: templateData.testStatus
          }
        }
      }
  },
  methods: {},
  components: {
    listArrange,
    divSpan,
    listHeaderTemplate
  }
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/qualityTp.vue